import { Point } from 'paper'

export const shapesLayout2 = [
  {
    shape: 'smudge',
    position: new Point(15, 15),
    scale: 1,
    flipX: true,
    rotate: 330,
    color: 'red',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(75, -50),
      rotate: 0
    }
  },
  {
    shape: 'boomerang',
    position: new Point(15, 28),
    scale: 1.5,
    rotate: 0,
    color: 'skinTone'
  },
  {
    shape: 'droplet',
    position: new Point(5, 32),
    scale: 1.25,
    rotate: 140,
    color: 'brown',
    overlay: {
      shape: 'overlay',
      scale: 1,
      translate: new Point(50, -100),
      rotate: 0
    }
  },
  {
    inset: 'garlic',
    position: new Point(5, 42),
    scale: 0.8,
    rotate: 0
  },
  {
    shape: 'golf_club',
    position: new Point(90, 7),
    scale: 1.5,
    rotate: 285,
    color: 'blue',
    overlay: {
      shape: 'overlay',
      scale: 1.25,
      translate: new Point(-150, -100),
      rotate: 180
    }
  },
  {
    shape: 'blob',
    position: new Point(90, 18),
    scale: 1.25,
    rotate: 0,
    color: 'yellow',
    overlay: 0
  },
  {
    inset: 'red-chili',
    position: new Point(95, 28),
    scale: 0.65,
    rotate: 0
  },
  {
    shape: 'tilde',
    position: new Point(85, 35),
    scale: 1.25,
    rotate: -30,
    color: 'purple',
    overlay: 0
  }
]
